import React, { useRef, useState } from "react";
import {
  POPUPCROSS_ICON,
} from "../../../../../utils/app-image-contant";
import UserProfile from "../../UserProfile";
import ChangePassword from "../../../auth/change-password";

const WebModal = ({ isProfile, isChangePassword }) => {
  const closeRef = useRef(null);
  const [closeModal, setCloseModal] = useState(false)
  return (
    <>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-target="#staticBackdrop"
        data-bs-keyboard="false"
        data-bs-backdrop="static"
      >
        <div
          className={`modal-dialog modal-dialog-centered ${isProfile?"modal-lg":"modal-md"}`}
          role="document"
        >
          <div class="modal-content p-4">
            <div className="d-flex justify-content-end">
              <img
                src={POPUPCROSS_ICON}
                alt=""
                ref={closeRef}
                className="cross_icon cursor-pointer"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={()=>setCloseModal(true)}
              />
            </div>

            {isProfile ? (
              <>
              <UserProfile closeRef={closeRef}/>
              </>
            ) : (
              <>{isChangePassword && <><ChangePassword closeRef={closeRef} closeModal={closeModal}/></>}</>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default WebModal;
